
import { all, call, put, takeLatest, select } from 'redux-saga/effects';

import { Scorecard } from 'actions/actionTypes';
import * as actions from 'actions/common/scorecard';

import { callScorecardInfo } from 'network/apis/common/scorecard';

function* loadScorecardInfoRequestSaga() {
    try {
        const scorecard = yield select(state => state.scorecard);
        
        const data = {
            scorecardType: scorecard.scorecardType
        }

        const response = yield call(callScorecardInfo, scorecard.gameRoundId, data);

        yield put(actions.loadScorecardInfoSuccess(response.data));
    } catch(error) {
        yield put(actions.loadScorecardInfoFailure(error.message));
    }
}

// Sign-In Sagas
export default function* root() {
    yield all([
        takeLatest(Scorecard.LOAD_SCORECARD_INFO_REQUEST, loadScorecardInfoRequestSaga),
    ]);
}